import { jsx as _jsx } from "react/jsx-runtime";
import { Box, RadioGroup, Stack } from '@emburse/embark-core';
import { useContext } from 'react';
import { useTranslation } from '../../../../../hooks/useTranslation';
import { CreateExpenseReportContext } from '../../../utils/CreateExpenseReportContext';
import CreateExpenseReportOptionsCard from './CreateExpenseReportOptionsCard';
import { CREATE_EXPENSE_REPORT_OPTIONS } from '../../../../../views/CreateExpenseReport/utils/constants';
function CreateExpenseReportOptionsList({ options }) {
    useTranslation();
    const { selectedOptionValue, setSelectedOptionValue, expenseReportCreationViewModel } = useContext(CreateExpenseReportContext);
    const onClickOption = (event) => {
        const optionValue = event.target.value;
        setSelectedOptionValue(parseInt(optionValue, 10));
    };
    return (_jsx(Box, { sx: { mt: 2 }, children: _jsx(RadioGroup, { name: "option", onChange: onClickOption, children: _jsx(Stack, { spacing: 2, alignItems: "stretch", children: options.map((option) => (_jsx(CreateExpenseReportOptionsCard, { option: option, selectedOptionValue: selectedOptionValue, disabled: !expenseReportCreationViewModel?.CardPrograms.length &&
                        option.value ===
                            CREATE_EXPENSE_REPORT_OPTIONS.CREDIT_CARD_TRANSACTIONS }, option.id))) }) }) }));
}
export default CreateExpenseReportOptionsList;
